import subscriptionAPI from '@/app/apis/main/subscription/subscription-api.js';

export default {
	/**
	 * @return {object} subscription period list
	 */
	async getSubscriptionPeriodList() {
		return subscriptionAPI.getSubscriptionPeriodList();
	},

	/**
	 * @param queryParams
	 * @return {object} Subscription List
	 * */
	async getSubscriptionList(queryParams) {
		return subscriptionAPI.getSubscriptionList(queryParams);
	},

	/**
	 * @params subscriptionId
	 * @return {object} Subscription Details
	 * */
	async getSubscriptionDetailsById(subscriptionId) {
		return subscriptionAPI.getSubscriptionDetailsById(subscriptionId);
	},

	/**
	 * Cancel a subscription by its ID along with remarks.
	 * 
	 * @param {number} subscriptionId - The ID of the subscription to cancel.
	 * @param {Object} updateDetails - Object containing update details.
	 * @param {string} updateDetails.status - The new status of the subscription.
	 * @param {string} [updateDetails.remarks] - Remarks or reason for the cancellation update (optional).
	 * @returns {Promise<void>} - A Promise that resolves when the update is successful.
	 * @throws {Error} - Throws an error if the update fails.
	*/
	async cancelSubscription(subscriptionId, updateDetails) {
		return subscriptionAPI.cancelSubscription(subscriptionId, updateDetails);
	},

	/**
	 * @params subscriptionId
	 * @return 204
	 * */
	async deleteSubscription(subscriptionId) {
		return subscriptionAPI.deleteSubscription(subscriptionId);
	},
	
	/**
	 * Update the status of a subscription by its ID along with remarks.
	 * 
	 * @param {number} subscriptionId - The ID of the subscription to update.
	 * @param {Object} updateDetails - Object containing update details.
	 * @param {string} updateDetails.status - The new status of the subscription.
	 * @param {string} [updateDetails.remarks] - Remarks or reason for the status update (optional).
	 * @returns {Promise<void>} - A Promise that resolves when the update is successful.
	 * @throws {Error} - Throws an error if the update fails.
	*/
	async updateSubscriptionStatusById(subscriptionId, updateDetails) {
		return subscriptionAPI.updateSubscriptionStatusById(subscriptionId, updateDetails);
	},
};